import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 4B15BF16-CD96-4427-9EA4-5A8B09F3A2B6
 * name message-settings
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-settings.svg
 * tags
 * - Settings 
 */
export const MessageSettingsIcon = createSvgIcon(<><path d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M11,24H13V22H11V24M7,24H9V22H7V24M15,24H17V22H15V24Z" /></>, 'MessageSettingsIcon');
export default MessageSettingsIcon